import axios from 'axios';
import type { AxiosInstance } from 'axios';
import { env } from '@/config/env';
import { API_TIMEOUT } from '@/config/constants';
import { installMockAdapter } from '@/mocks/mock-adapter';

let publicClient: AxiosInstance | null = null;

function createPublicClient(): AxiosInstance {
  const client = axios.create({
    baseURL: env.AUTH_BASE_URL,
    timeout: API_TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Install mock adapter if enabled
  if (import.meta.env.VITE_USE_MOCKS === 'true') {
    installMockAdapter(client);
    console.log('[Mock API] Public client mocks installed');
  }

  return client;
}

export function getPublicClient(): AxiosInstance {
  if (!publicClient) {
    publicClient = createPublicClient();
  }
  return publicClient;
}

export { unwrapContainer } from './http-client';
